import * as Scrivito from 'scrivito';
import { PodcastWidgetAttributes, PodcastWidgetId } from './podcast-widget-definitions';
import { HelperText, Message, WidgetTitle } from '../../utils/translations';
import { ValidationInfo } from '../../utils/type.utils';
import { HeadlineWidgetTag } from '../headline-widget';

Scrivito.provideEditingConfig(PodcastWidgetId, {
  title: WidgetTitle.PODCAST,
  titleForContent: (widget) => widget.get(PodcastWidgetAttributes.TITLE) as string,
  properties: Object.values(PodcastWidgetAttributes),
  attributes: {
    [PodcastWidgetAttributes.TITLE]: {
      title: HelperText.TITLE,
    },
    [PodcastWidgetAttributes.TITLE_COMPONENT]: {
      title: 'Hierarchie der Überschrift (HTML)',
      values: [
        { value: HeadlineWidgetTag.H1, title: '<h1>' },
        { value: HeadlineWidgetTag.H2, title: '<h2>' },
        { value: HeadlineWidgetTag.H3, title: '<h3>' },
        { value: HeadlineWidgetTag.H4, title: '<h4>' },
        { value: HeadlineWidgetTag.H5, title: '<h5>' },
        { value: HeadlineWidgetTag.H6, title: '<h6>' },
      ],
    },
  },
  validations: [
    [
      PodcastWidgetAttributes.TITLE,
      (value: string): ValidationInfo => {
        if (!value) {
          return {
            message: Message.TEXT_MISSING,
            severity: 'error',
          };
        }
        return undefined;
      },
    ],
  ],
  initialContent: {
    [PodcastWidgetAttributes.TITLE]: 'Podcast',
    [PodcastWidgetAttributes.TITLE_COMPONENT]: HeadlineWidgetTag.H3,
    [PodcastWidgetAttributes.THEME]: 'default',
  },
});
